// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"9e48f6b8","787":"26a9bb17","920":"d61a95b3"}[chunkId] + ".chunk.js";
};